import { createApi } from '@reduxjs/toolkit/query/react';
import { saveAs } from 'file-saver';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const servicesApi = createApi({
  reducerPath: 'servicesApi',
  baseQuery: createBaseQuery('services', { timeout: 0 }),
  endpoints: builder => ({
    getACICExportFile: builder.query({
      queryFn: async (params, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: `/acic/export_file`,
          responseHandler: async response => {
            const countHeader = response.headers.get('X-ACIC-Skipped-Count');
            const skippedCount = countHeader ? parseInt(countHeader, 10) : 0;
            const blob = await response.blob();
            return { blob, skippedCount: Number.isFinite(skippedCount) ? skippedCount : 0 };
          },
          cache: 'no-cache',
        });
        if (result.error) {
          return { error: result.error };
        }
        const payload = result.data ?? {};
        if (payload.blob) {
          saveAs(payload.blob, 'acic_export_file.xml');
        }
        return { data: { skippedCount: payload.skippedCount ?? 0 } };
      },
    }),
    getACICExportFileSingle: builder.query({
      queryFn: async (checkId, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: `/acic/export_file/${checkId}`,
          responseHandler: async response => {
            const countHeader = response.headers.get('X-ACIC-Skipped-Count');
            const skippedCount = countHeader ? parseInt(countHeader, 10) : 0;
            const blob = await response.blob();
            return { blob, skippedCount: Number.isFinite(skippedCount) ? skippedCount : 0 };
          },
          cache: 'no-cache',
        });
        if (result.error) {
          return { error: result.error };
        }
        const payload = result.data ?? {};
        if (payload.blob) {
          saveAs(payload.blob, `acic_export_${checkId}.xml`);
        }
        return { data: { skippedCount: payload.skippedCount ?? 0 } };
      },
    }),
    signACICResultUpload: builder.query({
      query: params => `/acic/sign_result_upload?${toQueryParams(params)}`,
      transformResponse: response => response.result,
    }),
  }),
});

export const {
  useLazyGetACICExportFileQuery,
  useLazyGetACICExportFileSingleQuery,
  useLazySignACICResultUploadQuery,
} = servicesApi;
